import { render, staticRenderFns } from "./empty-ratings.vue?vue&type=template&id=2ae2c3ed&scoped=true"
import script from "./empty-ratings.vue?vue&type=script&lang=js"
export * from "./empty-ratings.vue?vue&type=script&lang=js"
import style0 from "./empty-ratings.vue?vue&type=style&index=0&id=2ae2c3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2c3ed",
  null
  
)

export default component.exports